export default {
    "title": "Stocks / {{client}}",
    "description": "Stock files with download in PDF format",
    "last": {
        "recent": "Most recent stock file available",
        "date": "Date:"
    },
    "downloadButton": "Download",
    "stocksTableHeader": "<0>{{count}}</0> previous holdings files available",
    "stocksTableColumns": {
        "date": "Date",
        "download": "Download stocks"
    },
    "nameCollection": "stocks",
    "download": {
        "pdf": "Download PDF",
        "xls": "Download XLSX",
        "json": "Download JSON",
    }
}